const DELIVERY_GRACE_MS = 100;
const HIDDEN_DELIVERY_TIMEOUT_MS = 1000;
const MAX_DELIVERY_WAIT_MS = 30_000;

/**
 * Wait for the browser to finish the frame running when measurement stopped,
 * then allow its Long Animation Frame (LoAF) timing data to arrive.
 * Bound delivery to 30 seconds even when a visible page stops rendering.
 * If the tab is hidden and animation callbacks stop, report available data as incomplete.
 */
export function waitForPerfWindowDelivery(
  finish: (deliveryComplete: boolean) => void
): () => void {
  let finished = false;
  let graceTimer: ReturnType<typeof setTimeout> | undefined;
  let hiddenTimer: ReturnType<typeof setTimeout>;
  const deadlineTimer = setTimeout(() => complete(false), MAX_DELIVERY_WAIT_MS);
  const frameRequest = requestAnimationFrame(() => {
    graceTimer = setTimeout(() => complete(true), DELIVERY_GRACE_MS);
  });

  function cancel() {
    finished = true;
    cancelAnimationFrame(frameRequest);
    clearTimeout(graceTimer);
    clearTimeout(hiddenTimer);
    clearTimeout(deadlineTimer);
  }

  function complete(deliveryComplete: boolean) {
    if (finished) {
      return;
    }
    cancel();
    finish(deliveryComplete);
  }

  function checkHidden() {
    if (document.visibilityState !== 'visible') {
      complete(false);
      return;
    }
    hiddenTimer = setTimeout(checkHidden, HIDDEN_DELIVERY_TIMEOUT_MS);
  }
  hiddenTimer = setTimeout(checkHidden, HIDDEN_DELIVERY_TIMEOUT_MS);
  return cancel;
}
